/* eslint-disable max-len */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as UsersActions from '../actions/Users';
import del from '../Res/Icon/delete.png';
import edit from '../Res/Icon/edit.png';
import recover from '../Res/Icon/recover.png';
import Status2FA from './2FAStatus';
import UserStatus from './UserStatus';
import AddSecurityCodeModal from './AddSecurityCodeModal';
import utils from '../lib/utils';
const User = ({
  user,
  disabled,
  onDelete,
  onSetStatus,
  userApp,
  showUpdateUser,
  initialUpdateUserData,
  deleteMode,
  onRecover,
  userRole
}) => {
  const {
    _id: id,
    email,
    name,
    role,
    enabled,
    registerDate,
    lastLoggedIn,
    twoFactor,
    companyName,
    company,
    companyType,
  } = user;
  const isConpanyType = companyType || company?.companyType;
  const [modalStatus, setModalStatus] = useState(false);
  const checkSecurityCode = () => {
    onSetStatus(id, !twoFactor, '2FA');
    setModalStatus(false);
  };
  const onStatusChange = () => {
    if (twoFactor) {
      if (role === 'superAdmin' || role === 'companyGroupAdmin') {
        toast.error('Cannot disable 2FA for this user');
      } else {
        setModalStatus(true);
      }
    } else {
      onSetStatus(id, !twoFactor, '2FA');
    }
  };

  const getLastActiveDate = date => {
    if (date) {
      const lastLoggedIn = new Date(date);
      const now = new Date();

      const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;

      const timeDiffInMs = now.getTime() - lastLoggedIn.getTime();

      if (timeDiffInMs >= thirtyDaysInMs) return 'No Activity for last 30 day';

      return lastLoggedIn.toDateString();
    }
    return 'N/A';
  };
  return (
    <>
      <tr>
        {
          utils.filterCustomer(userRole) ? (<td>{id}</td>) : null
        }
        <td>{companyName || company.name}</td>
        <td>{email}</td>
        <td>{name}</td>
        <td>
          {isConpanyType !== 'manufacturer' ? role : role === 'superAdmin' ? 'manufacturer' : role}
        </td>
        <UserStatus
          canChange={disabled}
          enabled={enabled}
          onSetStatus={() => {
            onSetStatus(id, !enabled, 'Status');
          }}
        />
        <Status2FA canChange={disabled} twoFactor={twoFactor} onSetStatus={onStatusChange} />
        <td>{utils.getDateTimeFormat(registerDate, 'regular')}</td>
        <td>{getLastActiveDate(lastLoggedIn)}</td>
        {
          utils.filterCustomer(userRole) ? (
            (userApp.role === 'admin' ||
              userApp.role === 'enterpriseAdmin' ||
              userApp.role === 'superAdmin' ||
              userApp.role === 'companyGroupAdmin' ||
              userApp.role === 'companyGroupManager') && (
              <td style={{ minWidth: '100px' }}>
                {(userApp.role === 'superAdmin' ||
                  userApp.role === 'admin' ||
                  userApp.role === 'enterpriseAdmin' ||
                  userApp.role === 'companyGroupAdmin' ||
                  userApp.role === 'companyGroupManager') &&
                  ((user.role === 'superAdmin' && userApp.role === 'companyGroupManager') ||
                    (user.role === 'companyGroupAdmin' &&
                      userApp.role === 'companyGroupManager') ? null : !deleteMode ? (
                        <img
                          onClick={() => {
                            initialUpdateUserData(user);
                            showUpdateUser();
                          }}
                          className="actions-icon"
                          src={edit}
                          alt="edit"
                        />
                      ) : (
                    <img
                      onClick={() => onRecover(id)}
                      className="actions-icon"
                      src={recover}
                      alt="recover"
                    />
                  ))}

                {(userApp.role === 'companyGroupAdmin' && user.role === 'superAdmin') ||
                  (userApp.role === 'companyGroupAdmin' && user.role === 'companyGroupAdmin') ||
                  (userApp.role === 'companyGroupManager' && user.role === 'superAdmin') ||
                  (userApp.role === 'companyGroupManager' && user.role === 'companyGroupAdmin') ||
                  (userApp.role === 'companyGroupManager' && user.role === 'companyGroupManager') ||
                  ((userApp.role === 'admin' || userApp.role === 'enterpriseAdmin') &&
                    user.role === 'superAdmin') ||
                  ((userApp.role === 'admin' || userApp.role === 'enterpriseAdmin') &&
                    user.role === 'companyGroupAdmin') ||
                  ((userApp.role === 'admin' || userApp.role === 'enterpriseAdmin') &&
                    user.role === 'companyGroupManager') ||
                  ((userApp.role === 'admin' || userApp.role === 'enterpriseAdmin') &&
                    (user.role === 'admin' || user.role === 'enterpriseAdmin')) ? (
                  ''
                ) : (
                  // <Button
                  //   color="danger"
                  //   onClick={() => {
                  //     onDelete(id);
                  //   }}
                  //   disabled={disabled}
                  // >
                  //   Delete
                  // </Button>
                  <img
                    onClick={() => {
                      onDelete(user);
                    }}
                    disabled={disabled}
                    className="actions-icon"
                    src={del}
                    alt="delete"
                  />
                )}
              </td>
            )) : null}
      </tr>
      <AddSecurityCodeModal
        isOpen={modalStatus}
        onCancel={() => {
          setModalStatus(!modalStatus);
        }}
        onConfirm={checkSecurityCode}
        code2FA
        featureName='code2FA'
        
      />
    </>
  );
};

const mapStateToProps = state => ({
  userApp: state.AppState.user,
});

const mapDispatchToProps = dispatch => ({
  showUpdateUser: () => dispatch(UsersActions.showUpdateUser()),
  initialUpdateUserData: userObj => dispatch(UsersActions.initialUpdateUserData(userObj)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(User);
